var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "small mb-0 editable-description d-flex flex-row align-items-start",
      class: { "ml-4": !_vm.noMargin, clickable: !_vm.forceEditMode },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          !_vm.forceEditMode && _vm.toggleEditing(true)
        },
        keydown: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _vm.loading ? _c("inline-loader") : _vm._e(),
      _vm._v(" "),
      _vm.label
        ? _c(
            "span",
            {
              staticClass: "text-primary font-weight-bold py-1 capitalize",
              class: { "pl-2": !_vm.noMargin },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.$t("global.words.description")) + ":\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.noaIssue
        ? _c("icon", {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip",
                value: _vm.noaIssue,
                expression: "noaIssue",
              },
            ],
            staticClass: "ml-2 pt-2 text-danger",
            attrs: { name: "check-circle" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.editing
        ? [
            _c(
              "div",
              {
                staticClass: "form-group-material",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _vm._t(
                  "default",
                  function () {
                    return [
                      _c("input", {
                        ref: "descriptionInput",
                        staticClass:
                          "material-input form-control material-input-static-label form my-1 moregage-data",
                        attrs: {
                          id: "description-input",
                          type: "text",
                          placeholder: _vm.$t(
                            "documents.writeDocumentDescription"
                          ),
                        },
                        domProps: { value: _vm.newDescription },
                        on: {
                          input: _vm.handleDescriptionChange,
                          blur: _vm.handleClickOutside,
                          keypress: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.handleClickOutside.apply(null, arguments)
                          },
                        },
                      }),
                    ]
                  },
                  null,
                  {
                    newDescription: _vm.newDescription,
                    handleClickOutside: _vm.handleClickOutside,
                    handleDescriptionChange: _vm.handleDescriptionChange,
                  }
                ),
              ],
              2
            ),
          ]
        : [
            _c(
              "span",
              {
                staticClass: "document-description",
                class: {
                  "text-gray font-italic": !_vm.description,
                  "ml-2 py-1": _vm.label,
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.description || _vm.emptyDescriptionText) +
                    "\n    "
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }